import React, { useState, useEffect, useRef } from "react";
import { Grid, AutoSizer } from "react-virtualized";

import { useSelector, useDispatch } from "types/store";

import * as MarketReducer from "containers/CommunityMarket/MarketReducer";

import MarketItemCard from "components/CommunityMarket/MarketItemCard";

import styles from "./style.module.css";

const MarketGrid = (props) => {
  const { cards } = props;

  return (
    <div className={styles.marketGridContainer}>
      <AutoSizer>
        {({ height, width }) => {
          const minColumnWidth = 310;
          const columnCount = Math.floor((width - 50) / minColumnWidth);
          const columnWidth = Math.floor((width - 50) / columnCount);
          const rowCount = Math.ceil(cards.length / columnCount);

          return (
            <Grid
              cellRenderer={(props) => <RenderCard {...props} columnCount={columnCount} cards={cards} />}
              columnCount={columnCount}
              columnWidth={columnWidth}
              height={height}
              rowCount={rowCount}
              rowHeight={330}
              width={width}
            />
          );
        }}
      </AutoSizer>
    </div>
  );
};

const RenderCard = (props) => {
  const { columnIndex, rowIndex, style, cards, columnCount, ...retProps } = props;

  const index = rowIndex * columnCount + columnIndex;
  const card = cards[index];

  return (
    <div className={styles.marketGridCell} key={columnIndex + "__" + rowIndex} style={style}>
      {card && <MarketItemCard {...card} />}
    </div>
  );
};

export default MarketGrid;
